import { useContext } from "react";
import PusherContext from "../contexts/pusherContext";

const usePusher = () => {
  const pusher = useContext(PusherContext);
  return pusher;
};

export default usePusher;
